import React, { useState, useMemo, useEffect, useCallback } from 'react';
import {
  Box,
  ButtonBase,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
} from '@material-ui/core';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { KeyboardTimePicker } from '@material-ui/pickers';
import _ from 'lodash';
import { connect } from 'react-redux';
import { DeleteOutline } from '@material-ui/icons';
import { AutoCompleteSelect } from '../../../../components';
import { ArrowLeftIcon, EditIcon, SettingIcon, TimeIcon, ExportIcon, DateIcon } from '../../../../components/Icon';
import Dialog from '../../../../components/Dialog';
import rou from '../../../../router';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import { authNameE } from '../../../../utils/userFuncs';
import { downloadFileById, initValue, useGetUserInfo } from '../../../../utils';
import DatePicker from '../Header/DatePicker';
import VerifyAccountPop from '../../../../components/Login/VerifyAccountPop';
import { alertMsg } from '../../../../apis/commlogic';
import { KeyboardDatePicker } from '../../../../components/DatePicker';
import { store } from '../../../../redux';
import { LOADING_HIDE, LOADING_SHOW } from '../../../../redux/constant';
import Status from './Status';
import ClockBtn from './ClockBtn';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: '4.375rem',
    left: '6.25rem',
    right: '0',
    bottom: '0',
    background: '#fff',
  },
  toolbar: {
    height: '4.063rem',
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    color: '#538fff',
    marginBottom: '1.875rem',
    padding: '0 3.437rem',
    boxShadow: '0 1px 0 0 #e4e7eb',
    fontFamily: 'NotoSans-Medium',
  },
  arrowLeftIcon: {
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
  },
  back: {
    paddingLeft: '1rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '1.43',
  },
  attendance: {
    fontSize: '2.25rem',
    fontWeight: 'bold',
    color: '#001d63',
    fontFamily: 'NotoSans-Bold',
  },
  tableContainer: {
    maxHeight: 'calc(100vh - 15.875rem)',
    margin: '2.125rem 0 0 0.875rem',
    padding: '0 0 0 1.488rem',
    width: '97%',
  },
  table: {
    position: 'relative',
    minWidth: '65rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0 1rem ',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        padding: '1rem',
        backgroundColor: '#fff',
        fontSize: '0.875rem',
        fontFamily: 'NotoSans-Bold',
      },
    },
    '& .MuiTableBody-root': {
      '& :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
    },
  },
  status: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  tableHead: {
    whiteSpace: 'nowrap',
  },
  editIcon: {
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    background: '#4c93ff !important',
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
      background: '#4c93ff !important',
      color: '#fff',
    },
  },
  clearIcon: {
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    background: '#4c93ff !important',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
      background: '#4c93ff !important',
      color: '#fff',
    },
  },
  clearIconDisabled: {
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    background: '#d0d0d0 !important',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
      background: '#d0d0d0 !important',
      color: '#fff',
    },
  },
  filter: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
    whiteSpace: 'nowrap',
    paddingRight: '0.938rem',
  },
  setting: {
    width: '7.188rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    justifyContent: 'center',
  },
  autoCompleteSelect: {
    marginRight: '1.563rem',
  },
  dialogtitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    marginBottom: '0.625rem',
  },
  timeIcon: {
    fontSize: '1.25rem',
    color: theme.palette.primary.main,
  },
  timePicker: {
    width: '100%',
    '& .MuiInputBase-root': {
      padding: '0 0.625rem 0 1.25rem',
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '19.375rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium !important',
    },
  },
  checkbox: {
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.status.green,
    },
    '&.MuiCheckbox-root': {
      color: '#c0c6cb',
    },
  },
  check: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
  },
  loginBtn: {
    width: '7.188rem',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '10px',
    height: '2.5rem',
    marginRight: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: '#ffffff',
    fontWeight: '500',
  },
  inputBox: {
    height: '3.5rem',
    padding: '0 1.063rem 0 1.125rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    marginBottom: '0.623rem',
    '& input': {
      color: '#525e6c',
      fontSize: '1rem',
      fontFamily: 'NotoSans-Medium',
    },
  },
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    color: '#5f9df6',
    marginRight: '0.5rem',
  },
  clearBody: {
    color: theme.palette.font.main,
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    lineHeight: '1.875rem',
  },
  exportIcon: {
    width: '7.188rem',
    height: '2.25rem',
    borderRadius: '0.625rem',
    backgroundColor: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    display: 'flex',
    textDecoration: 'none',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogBodyDatePicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '0.0625rem solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      width: '18.938rem',
      height: '3rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      padding: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0.75rem',
    },
  },
  Picon: {
    color: '#538fff',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));

function Attendance(props) {
  const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
  const [rosterId, setRosterId] = useState(dutyDateInfo?.id ?? -1);
  const rosterIndex = dutyDateInfo?.index ?? 0;
  const [dialog, setDialog] = useState(false);
  const [selectRoster, setSelectRoster] = useState(rosterIndex);
  const [edit, setEdit] = useState({});
  const [data, setData] = useState(null);
  const [roster, setRoster] = useState([]);
  const [check, setCheck] = useState(false);
  const [previous, setPrevious] = useState(false);
  const [rolePermissions, setRolePermissions] = useState();
  const [selectDate, SetSelectDate] = useState(dutyDateInfo ? dutyDateInfo.date : moment());
  const [vertifyInfo, setVertifyInfo] = useState(false);
  const userInfo = useGetUserInfo();
  const classes = useStyles();
  const [clearDialogConfirmOpen, setClearDialogConfirmOpen] = useState(false);
  const [clockConfirmOpen, setClockConfirmOpen] = useState(false);
  const [clockInfo, setClockInfo] = useState(null);
  const initExportDialog = {
    open: false,
    type: 'single',
    dateFrom: moment(selectDate).valueOf(),
    dateTo: moment(selectDate).valueOf(),
    rosterName: '',
  };
  const [exportDialog, setExportDialog] = useState(initExportDialog);
  const [errorMessage, setErrorMessage] = useState(null);
  const [dateInvalid, setDateInvalid] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(false);

  let count = 0;

  const hideLoading = () => {
    if (count <= 0) return;
    count--;
    if (count === 0) {
      store.dispatch({ type: LOADING_HIDE });
    }
  };

  const showLoading = () => {
    if (count === 0) {
      store.dispatch({ type: LOADING_SHOW });
    }
    count++;
  };

  const handleShowTime = ({ role }) => {
    if (rolePermissions) {
      switch (role?.toLocaleUpperCase()) {
        case 'WARDIC':
          return rolePermissions.icYn === 1;
        case 'NURSE':
          return rolePermissions.nurseYn === 1;
        case 'CLERK':
        case 'SUPPORTINGSTAFF':
          return rolePermissions.clerkYn === 1;
        default:
          return true;
      }
    }
  };

  // get List API
  const getListAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getDaCheckList({ templateRosterId: rosterId, wardId: props.wardId });
      setData(result);
    } catch (error) {
      console.log('-----Get CheckInOut error----->', error);
    }
  };

  // get setting detail API
  const getSettingAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getSettingDetail();
      setRolePermissions(result);
    } catch (error) {
      console.log('-----Get Setting Detail error----->', error);
    }
  };

  useEffect(() => {
    if (rosterId !== -1) {
      (async () => {
        await getListAPI();
      })();
      (async () => {
        await getSettingAPI();
      })();
    }

    if (rosterId === -1) {
      setData(null);
    }
  }, [rosterId]);

  const handleTimeInit = (Time) => {
    return Time === null ? '-' : Time;
  };

  const list = useMemo(() => {
    let checkList = [];

    if (Array.isArray(data) && data.length > 0) {
      checkList = _.map(data, (item) => {
        let status = null;
        switch (item.status) {
          case 'Not on duty':
            status = 0;
            break;
          case 'Clock-in':
            status = 1;
            break;
          case 'Clocked-out':
            status = 2;
            break;
          case 'Day off':
            status = 3;
            break;
          default:
            break;
        }
        return {
          ...item,
          id: item.dutyFunctionalAreaStaffId,
          corpId: item.corpId ?? null,
          tempId: item.dutyTempUserId ?? null,
          staffName: item.staffName,
          functionalArea: _.map(item.cubicles, (cubicle) => {
            return cubicle.name;
          }),
          role: item.role,
          rank: item.rankCode,
          edit: 'edit',
          clockBtn: 'btn',
          clockIn: handleTimeInit(item.checkinTime),
          clockOut: handleTimeInit(item.checkoutTime),
          status: status,
        };
      });
    }

    return { checkList };
  }, [data]);

  // update List API
  const clockAPI = async (clockInTime, clockOutTime, corpId, tempId, staffName, action, status) => {
    try {
      let payload;
      if (clockOutTime === null) {
        payload = {
          checkinTime: clockInTime,
          templateRosterId: rosterId,
          corpId: corpId,
          dutyTempUserId: tempId,
          staffName: staffName,
          action,
          status
        };
      } else if (clockInTime === null) {
        payload = {
          checkoutTime: clockOutTime,
          templateRosterId: rosterId,
          corpId: corpId,
          dutyTempUserId: tempId,
          staffName: staffName,
          action,
          status
        };
      } else {
        payload = {
          checkinTime: clockInTime,
          checkoutTime: clockOutTime,
          templateRosterId: rosterId,
          corpId: corpId,
          dutyTempUserId: tempId,
          staffName: staffName,
          action,
          status
        };
      }
      
      dutyAssignAPI.saveCheckInOut(payload).then((res) => {
        const { result } = res;
        switch (result) {
          case 'success':
            getListAPI();
            break;
          case 'login':
            setVertifyInfo({ corpId, status, tempId, staffName });
            setTimeout(() => {
              try {
                document.querySelector('input[type=password]').focus();
              } catch (e) {
                console.error(e);
              }
            }, 500);
            break;
          case 'confirm':
            setClockInfo({
              clockInTime: clockInTime,
              clockOutTime: clockOutTime,
              corpId: corpId,
              tempId: tempId,
              staffName: staffName,
            });
            setClockConfirmOpen(true);
            break;
          case 'completed':
             handleCompletedInOut();
            break;
          default:
            break;
        }
      });

      // await getListAPI();
    } catch (error) {
      console.log('-----Update CheckInOut error----->', error);
    }
  };

  // getRosterAPI
  const getRosterAPI = async () => {
    try {
      const { result } = await dutyAssignAPI.getTemplateRoster({
        timeStart: moment(selectDate).format('DD-MM-YYYY'),
        timeEnd: moment(selectDate).format('DD-MM-YYYY'),
      });
      setRoster([...result]);
    } catch (error) {
      console.log('-----Update Duty error----->', error);
    }
  };

  const getExportAPI = useCallback(async (payload) => {
    try {
      showLoading();
      await downloadFileById(
        () => {
          return new Promise((resolve, reject) => {
            dutyAssignAPI
              .getDaExportAttendanceRequest(payload)
              .then((res) => {
                resolve(res);
                hideLoading();
              })
              .catch((error) => {
                reject(error);
                hideLoading();
              });
          });
        },
        () => {
          return `Duty Attendance Export Excel_${moment().valueOf()}`;
        }
      );
    } catch (error) {
      hideLoading();
      console.log('-----Export error----->', error);
    }
  }, []);

  useEffect(() => {
    setRoster([]);
    if (moment(selectDate).isBetween(moment('1976-01-01', 'yyyy-MM-DD'), moment('9999-12-31', 'yyyy-MM-DD'))) {
      (async () => {
        await getRosterAPI();
      })();
      sessionStorage.setItem('dutyInfo', JSON.stringify({ date: selectDate, id: -1, index: 0 }));
    }
  }, [props.rouList, selectDate]);

  useEffect(() => {
    if (Array.isArray(rosterList) && rosterList.length > 0) {
      sessionStorage.setItem(
        'dutyInfo',
        JSON.stringify({ date: selectDate, id: rosterList[selectRoster].id, index: selectRoster })
      );
      setRosterId(rosterList[selectRoster].id);
    }
    return () => {
      setRosterId(-1);
    };
  }, [selectRoster, roster]);

  const rosterList = useMemo(() => {
    let rosterlist = [];

    if (Array.isArray(roster) && roster.length > 0) {
      rosterlist = _.map(_.orderBy(roster, ['rosterOrder'], ['asc']), (item, index) => {
        return {
          id: item.dutyTemplateRosterId,
          value: index,
          text: item.rosterCode,
          rosterOrder: item.rosterOrder,
        };
      });
    }

    if (Array.isArray(roster) && roster.length === 0) {
      rosterlist = [];
    }

    return rosterlist;
  }, [roster]);

  const statusList = [
    i18n.t('DUTYASSIGN_ATTENDANCE_NOT_ONDUTY'),
    i18n.t('DUTYASSIGN_ATTENDANCE_CLOCKEDIN'),
    i18n.t('DUTYASSIGN_ATTENDANCE_CLOCKEDOUT'),
    i18n.t('DUTYASSIGN_ATTENDANCE_DAY_OFF'),
    i18n.t('DUTYASSIGN_ATTENDANCE_CLOCKIN'),
    i18n.t('DUTYASSIGN_ATTENDANCE_CLOCKOUT'),
  ];

  const tableHead = [
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_CLOCK'), position: 'left' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_STAFF'), position: 'left' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_AREA'), position: 'left' },
    // { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_ROLE'), position: 'left' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_RANK'), position: 'left' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_STATUS'), position: 'center' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_CLOCKIN'), position: 'left' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_CLOCKOUT'), position: 'left' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_TABLE_EDIT'), position: 'center' },
    { name: i18n.t('DUTYASSIGN_ATTENDANCE_CLEAR_TABLE_TITLE'), position: 'center' },
  ];

  const backHandle = () => {
    props.history.goBack(1);
  };

  const clockBtnHandle = (status, corpId, tempId, staffName, action) => {
    let isToday = '';
    if (moment(selectDate).format('YYYY-MM-DD') === moment().add('1', 'd').format('YYYY-MM-DD')) {
      isToday = '-';
    } else if (moment(selectDate).format('YYYY-MM-DD') === moment().add('-1', 'd').format('YYYY-MM-DD')) {
      isToday = '+';
    }

    if (status === 0) {
      (async () => {
        await clockAPI(moment().format(`hh:mm${isToday} a`), null, corpId, tempId, staffName, action, status);
      })();
      return null;
    } else if (status === 1) {
      return clockAPI(null, moment().format(`hh:mm${isToday} a`), corpId, tempId, staffName, action, status);
    }
  };

  const clockHandler = (row) => {
    const { status, corpId, tempId, staffName } = row;
    (async () => {
      await clockBtnHandle(status, corpId, tempId, staffName, 'PRE');
    })();
  };

  const showClockBtn = (row) => {
    const { status, corpId, tempId, index } = row;

    if (moment(moment(selectDate)).isBetween(moment().add(-2, 'd'), moment().add(2, 'd'))) {
      if (status === 0) {
        return (
          <ClockBtn
            id={`dutyassign-clock-in-${corpId ?? tempId ?? index}`}
            onClick={() => {
              clockHandler(row);
            }}
            status={status}
          >
            {statusList[4]}
          </ClockBtn>
        );
      } else if (status === 1) {
        return (
          <ClockBtn
            id={`dutyassign-clock-out-${corpId ?? tempId ?? index}`}
            onClick={() => {
              clockHandler(row);
            }}
            status={status}
          >
            {statusList[5]}
          </ClockBtn>
        );
      } else {
        return null;
      }
    }
    return null;
  };

  const handleSelectDate = (value) => {
    setSelectRoster(0);
    SetSelectDate(value);
  };

  const handleVertifySucces = () => {
    const { status, corpId, tempId, staffName } = vertifyInfo;

    (async () => {
      await clockBtnHandle(status, corpId, tempId, staffName);
    })();

    setVertifyInfo(false);
  };

  const handleVertifyFail = () => {
    alertMsg(i18n.t('DUTYASSIGN_ATTENDANCE_VERTIFY_FAIL'), _.uniqueId('warning_'), 'warning');
  };
   const handleCompletedInOut = () => {
    alertMsg(i18n.t('DUTYASSIGN_COMPLETED_IN_OUT'), _.uniqueId('warning_'), 'warning');
    getListAPI();
  };

  const handClearClock = async () => {
    setClearDialogConfirmOpen(false);
    await dutyAssignAPI.clearCheckInOut({
      templateRosterId: rosterId,
      corpId: edit.corpId,
      dutyTempUserId: edit.tempId,
      staffName: edit.staffName,
    });
    await getListAPI();
  };

  useEffect(() => {
    checkError();
  }, [exportDialog]);

  const checkError = () => {
    let errorMsg = null;
    if (exportDialog.dateFrom === null || exportDialog.dateTo === null) {
      setErrorMessage(null);
    } else if (exportDialog.dateFrom > exportDialog.dateTo) {
      errorMsg = i18n.t('DUTYASSIGN_ATTENDANCE_EXPORT_MIN_ERROR');
    } else {
      const dayOffset = moment(exportDialog.dateTo).diff(moment(exportDialog.dateFrom), 'days');
      const monthOffset = moment(exportDialog.dateTo).diff(moment(exportDialog.dateFrom), 'months');
      if (monthOffset > 5) {
        errorMsg = i18n.t('DUTYASSIGN_ATTENDANCE_EXPORT_TOO_LONG_ERROR');
      }
    }
    setErrorMessage(errorMsg);
  };

  return (
    <div className={classes.root}>
      <div className={classes.toolbar}>
        <ButtonBase onClick={backHandle} id="4">
          <ArrowLeftIcon className={classes.arrowLeftIcon} />
          <Typography className={classes.back}>{i18n.t('DUTYASSIGN_BACK')}</Typography>
        </ButtonBase>
      </div>
      <Box display="flex" justifyContent="space-between" style={{ margin: '0 3.438rem' }}>
        <Typography className={classes.attendance}>{i18n.t('DUTYASSIGN_ATTENDANCE')}</Typography>
        <Box display="flex" alignItems="center">
          <Typography className={classes.filter}>{i18n.t('DUTYASSIGN_ROSTER_FILTER')} :</Typography>
          <DatePicker handleSelectDate={handleSelectDate} id="DutyAssign-DatePicker-abp" selectDate={selectDate} />
          <AutoCompleteSelect
            id="5"
            itemList={rosterList}
            value={selectRoster}
            onChange={(value) => {
              setSelectRoster(value);
            }}
            height="2.5rem"
            placeholder={i18n.t('DUTYASSIGN_ATTENDANCE_PLACEHOLDER')}
            className={classes.autoCompleteSelect}
          />
          {props.isLogin && props.roleMap[authNameE.dutyAssign_Edit_Attandence_Setting] && (
            <Link id="6" className={classes.setting} to={rou.AttendanceSettingRou.path}>
              <SettingIcon style={{ fontSize: '1.25rem' }} />
              <Typography style={{ marginLeft: '0.5rem' }}>{i18n.t('DUTYASSIGN_SETTING')}</Typography>
            </Link>
          )}
          <Link
            className={classes.exportIcon}
            id="export-icon"
            style={{ marginLeft: '1rem', fontSize: '1rem', borderWidth: 0 }}
            variant="outlined"
            disabled={!selectDate || !rosterList[selectRoster]}
            onClick={() => {
              setDateInvalid(false);
              setExportDialog({ ...initExportDialog, open: true });
            }}
          >
            <ExportIcon style={{ width: '1.2rem', color: '#fff', marginRight: '0.5rem' }} />
            <Typography>{i18n.t('DUTYASSIGN_EXPORT')}</Typography>
          </Link>
        </Box>
      </Box>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              {tableHead.map((item, index) => {
                const { name, position } = item;
                return (
                  <TableCell align={position} key={name}>
                    {name.toLocaleUpperCase()}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {list.checkList.map((row, index) => {
              const { staffName, functionalArea, role, rank, status, clockIn, clockOut, corpId, tempId } = row;
              return (
                <TableRow key={initValue(initValue(corpId, tempId), staffName)}>
                  <TableCell align="left" style={{ width: '9rem' }}>
                    {showClockBtn({ ...row, index })}
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: '10.5rem' }}>
                    {staffName}
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: '8.5rem' }}>
                    {functionalArea.toString()}
                  </TableCell>
                  {/* <TableCell align="left">{role}</TableCell> */}
                  <TableCell align="left" style={{ width: '4.5rem' }}>
                    {rank}
                  </TableCell>
                  <TableCell align="center" className={classes.status}>
                    <Status status={status}>{statusList[status]}</Status>
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: '7.5rem' }}>
                    {handleShowTime({ role }) ? clockIn : '-'}
                  </TableCell>
                  <TableCell align="left" style={{ minWidth: '7.5rem' }}>
                    {handleShowTime({ role }) ? clockOut : '-'}
                  </TableCell>
                  <TableCell align="center" style={{ width: '4.5rem' }}>
                    {props.roleMap[authNameE.dutyAssign_Edit_Clock_Time] && status !== 3 && (
                      <ButtonBase
                        id={`dutyassign-attendance-edit-${corpId ?? tempId ?? index}`}
                        className={classes.editIcon}
                        onClick={() => {
                          if (props.isLogin) {
                            setEdit({
                              ...edit,
                              corpId: corpId,
                              tempId: tempId,
                              staffName: staffName,
                              clockIn: /\d-/.test(clockIn) ? moment(clockIn, 'hh:mm- a').format('hh:mm a') : clockIn,
                              clockOut: /\+/.test(clockOut) ? moment(clockOut, 'hh:mm+ a').format('hh:mm a') : clockOut,
                            });
                            setCheck(/\+/.test(clockOut));
                            setPrevious(/\d-/.test(clockIn));
                            setDialog(true);
                          }
                        }}
                      >
                        <EditIcon />
                      </ButtonBase>
                    )}
                  </TableCell>
                  <TableCell align="center" style={{ width: '10.5rem' }}>
                    {props.roleMap[authNameE.dutyAssign_Edit_Clock_Time] && status !== 3 && (
                      <ButtonBase
                        style={{
                          display: status === null || status === undefined || status === 0 ? 'none' : 'inline-flex',
                        }}
                        id={`dutyassign-attendance-clear-${corpId ?? tempId ?? index}`}
                        className={classes.clearIcon}
                        onClick={async () => {
                          if (props.isLogin) {
                            setEdit({
                              ...edit,
                              corpId: corpId,
                              tempId: tempId,
                              staffName: staffName,
                            });
                            setClearDialogConfirmOpen(true);
                          }
                        }}
                      >
                        <DeleteOutline />
                      </ButtonBase>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {clockConfirmOpen ? (
        <Dialog
          open={clockConfirmOpen}
          id="DutyAssign-DiaLog-aik"
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          title={i18n.t('DUTYASSIGN_ROSTER_COPY_INFO')}
          handleCancel={() => {
            setClockConfirmOpen(false);
          }}
          handleClose={() => {
            setClockConfirmOpen(false);
          }}
          handleConfirm={() => {
            clockAPI(
              clockInfo?.clockInTime,
              clockInfo?.clockOutTime,
              clockInfo?.corpId,
              clockInfo?.tempId,
              clockInfo?.staffName
            );
            setClockConfirmOpen(false);
          }}
        >
          <div className={classes.publishBody}>
            {clockInfo?.clockOutTime === null
              ? i18n.t('DUTYASSIGN_ROSTER_VIEW_ROSTER_CONFIRM_CLOCK_IN', { value: clockInfo?.staffName })
              : i18n.t('DUTYASSIGN_ROSTER_VIEW_ROSTER_CONFIRM_CLOCK_OUT', { value: clockInfo?.staffName })}
          </div>
        </Dialog>
      ) : null}
      {clearDialogConfirmOpen ? (
        <Dialog
          open={clearDialogConfirmOpen}
          id="DutyAssign-DiaLog-aik"
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          title={i18n.t('DUTYASSIGN_ATTENDANCE_CLEAR_DIALOG_TITLE')}
          handleCancel={() => {
            setClearDialogConfirmOpen(false);
          }}
          handleClose={() => {
            setClearDialogConfirmOpen(false);
          }}
          handleConfirm={handClearClock}
        >
          <div className={classes.clearBody}>
            {i18n.t('DUTYASSIGN_ATTENDANCE_CLEAR_CLOCK_IN_OUT_DIALOG_BODY', { value: edit.staffName })}
          </div>
        </Dialog>
      ) : null}
      <Dialog
        title={i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_TITLE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_SAVE')}
        cancelID="DutyAssign-Dialog-agw-cancel"
        confirmID="DutyAssign-Dialog-agw-confirm"
        closeID="DutyAssign-Dialog-agw-close"
        open={dialog}
        id="DutyAssign-Dialog-abq"
        handleClose={() => {
          setDialog(false);
        }}
        handleCancel={() => {
          setDialog(false);
        }}
        handleConfirm={() => {
          if (
            edit.clockIn === '-' ||
            edit.clockIn === 'Invalid date' ||
            (!check &&
              !previous &&
              moment(moment(edit.clockIn, 'hh:mm a')).diff(moment(edit.clockOut, 'hh:mm a'), 'minute') > 0)
          ) {
            return;
          }

          if (edit.clockOut === '-' || edit.clockOut === 'Invalid date') {
            (async () => {
              await clockAPI(
                previous ? moment(edit.clockIn, 'hh:mm a').format('hh:mm- a') : edit.clockIn,
                null,
                edit.corpId,
                edit.tempId,
                edit.staffName
              );
            })();

            setDialog(false);
            return null;
          }
          (async () => {
            await clockAPI(
              previous ? moment(edit.clockIn, 'hh:mm a').format('hh:mm- a') : edit.clockIn,
              check ? moment(edit.clockOut, 'hh:mm a').format('hh:mm+ a') : edit.clockOut,
              edit.corpId,
              edit.tempId,
              edit.staffName
            );
          })();

          setDialog(false);
        }}
        confirmStyle={{
          opacity:
            edit.clockIn === '-' ||
            edit.clockIn === 'Invalid date' ||
            (!check &&
              !previous &&
              moment(moment(edit.clockIn, 'hh:mm a')).diff(moment(edit.clockOut, 'hh:mm a'), 'minute') > 0)
              ? 0.2
              : 1,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <div className={classes.dialogtitle}>{i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_CLOCK-IN-TITLE')} </div>
            <KeyboardTimePicker
              id="3"
              className={classes.timePicker}
              keyboardIcon={<TimeIcon className={classes.timeIcon} />}
              inputVariant="outlined"
              InputAdornmentProps={{ position: 'end' }}
              format="hh:mm a"
              variant="dialog"
              placeholder={i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_CLOCK-IN-INPUT')}
              value={edit.clockIn === '-' ? null : moment(edit.clockIn, 'hh:mm a')}
              onChange={(value) => {
                if ((value?.['_i'] && value?.['_i']?.[6] === '_') || value === null) {
                  setEdit({ ...edit, clockIn: '-' });
                  return;
                }
                setEdit({ ...edit, clockIn: moment(value).format('hh:mm a') });
              }}
            />
            <div className={classes.check}>
              <Checkbox
                className={classes.checkbox}
                checked={previous}
                onChange={() => setPrevious(!previous)}
                id="DutyAssign-Checkbox-abc"
              />
              {i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_PREVIOUS_DAY')}
            </div>
          </div>
          <div>
            <div className={classes.dialogtitle}>{i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_CLOCK-OUT-TITLE')}</div>
            <KeyboardTimePicker
              id="5"
              className={classes.timePicker}
              keyboardIcon={<TimeIcon className={classes.timeIcon} />}
              inputVariant="outlined"
              InputAdornmentProps={{ position: 'end' }}
              format="hh:mm a"
              variant="dialog"
              placeholder={i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_CLOCK-OUT-INPUT')}
              value={edit.clockOut === '-' ? null : moment(edit.clockOut, 'hh:mm a')}
              onChange={(value) => {
                if ((value?.['_i'] && value?.['_i']?.[6] === '_') || value === null) {
                  setEdit({ ...edit, clockOut: '-' });
                  return;
                }
                setEdit({ ...edit, clockOut: moment(value).format('hh:mm a') });
              }}
            />
            <div className={classes.check}>
              <Checkbox
                className={classes.checkbox}
                checked={check}
                onChange={() => setCheck(!check)}
                id="DutyAssign-Checkbox-abr"
              />
              {i18n.t('DUTYASSIGN_ATTENDANCE_EDIT_NEXT_DAY')}
            </div>
          </div>
        </div>
      </Dialog>
      <VerifyAccountPop
        open={Boolean(vertifyInfo)}
        id="DutyAssign-VerifyAccountPop-abs"
        onClose={() => {
          setVertifyInfo(false);
        }}
        corpId={vertifyInfo.corpId}
        successHandle={handleVertifySucces}
        failHandle={handleVertifyFail}
      />
      {exportDialog.open ? (
        <Dialog
          open={exportDialog.open}
          title={i18n.t('DUTYASSIGN_ATTENDANCE_EXPORT_TITLE')}
          cancel={i18n.t('DUTYASSIGN_CANCEL')}
          confirm={i18n.t('DUTYASSIGN_CONFIRM')}
          cancelID="DutyAssign-Dialog-period-cancel"
          confirmID="DutyAssign-Dialog-period-confirm"
          closeID="DutyAssign-Dialog-period-close"
          handleCancel={() => {
            setExportDialog(initExportDialog);
          }}
          handleClose={() => {
            setExportDialog(initExportDialog);
          }}
          handleConfirm={() => {
            setConfirmDisabled(true);
            const from = exportDialog.dateFrom;
            const to = exportDialog.dateTo;
            const payload = {
              rosterCode: rosterList[selectRoster].text,
              from,
              to,
              wardId: props.wardId,
            };
            getExportAPI(payload);
            setTimeout(() => {
              setConfirmDisabled(false);
            }, 2000);
          }}
          dialogheadStyle={{ marginBottom: 0 }}
          disabled={
            confirmDisabled ||
            dateInvalid ||
            errorMessage !== null ||
            exportDialog.dateFrom === null ||
            exportDialog.dateTo === null
          }
        >
          <div
            className="publish-dialog-roster-name"
            id="publish-by-period-roster-name"
            style={{ marginBottom: '1.75rem' }}
          >
            <span style={{ color: 'currentColor', fontSize: '1.025rem' }}>{rosterList[selectRoster]?.text}</span>
          </div>
          <div className="publish-dialog-publish-period-content">
            <div className="publish-dialog-period-date" style={{ display: 'flex', alignItems: 'flex-start' }}>
              <div style={{ flex: 1, paddingRight: '.5rem' }}>
                <KeyboardDatePicker
                  className={classes.dialogBodyDatePicker}
                  type="dialog"
                  size="small"
                  keyboardIcon={<DateIcon className={classes.Picon} />}
                  value={exportDialog.dateFrom}
                  onChange={(value) => {
                    if (value?.isValid() && value.valueOf() > 0) {
                      setDateInvalid(false);
                      setExportDialog({
                        ...exportDialog,
                        dateFrom: value.valueOf(),
                      });
                    } else {
                      if (value === null) {
                        setExportDialog({
                          ...exportDialog,
                          dateFrom: null,
                        });
                      }
                      setDateInvalid(true);
                    }
                  }}
                  id="export-dialog-datepicker-type-period-date-from"
                  variant="dialog"
                  format="DD-MM-yyyy"
                  inputVariant="outlined"
                  InputAdornmentProps={{
                    position: 'end',
                    id: 'export-dialog-datepicker-type-period-date-from-button',
                  }}
                  placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_START_INPUT')}
                  minDate={moment('1976-01-01', 'YYYY-MM-DD')}
                />
              </div>

              <div style={{ flex: 1, paddingRight: '.5rem' }}>
                <KeyboardDatePicker
                  className={classes.dialogBodyDatePicker}
                  type="dialog"
                  size="small"
                  keyboardIcon={<DateIcon className={classes.Picon} />}
                  value={exportDialog.dateTo}
                  onChange={(value) => {
                    if (value?.isValid() && value.valueOf() > 0) {
                      setDateInvalid(false);
                      setExportDialog({
                        ...exportDialog,
                        dateTo: value.valueOf(),
                      });
                    } else {
                      if (value === null) {
                        setExportDialog({
                          ...exportDialog,
                          dateTo: null,
                        });
                      }
                      setDateInvalid(true);
                    }
                  }}
                  id="export-dialog-datepicker-type-period-date-to"
                  variant="dialog"
                  format="DD-MM-yyyy"
                  inputVariant="outlined"
                  InputAdornmentProps={{
                    position: 'end',
                    id: 'export-dialog-datepicker-type-period-date-to-button',
                  }}
                  placeholder={i18n.t('DUTYASSIGN_ROSTER_ADD_END_INPUT')}
                />
              </div>
            </div>
            <Box style={{ display: 'flex', flexDirection: 'row' }}>
              <Typography className={classes.errorMsg}>{errorMessage}</Typography>
            </Box>
          </div>
        </Dialog>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLogin: state.loginInfo.flag,
  wardId: state.loginInfo.wardId,
  roleMap: state.roleMap,
  userRole: state.userRole,
  loginInfo: state.loginInfo,
  rouList: state.rouList,
});

export default connect(mapStateToProps)(Attendance);
